// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"970":"9b29e12a","3399":"649683c2","5396":"39be7f2a","6116":"39be7f2a","8405":"54e6c856","9464":"39073b26"}[chunkId] + ".chunk.css";
};